import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";
import {
	getInventoryLevelEventQuantitySpcSamplingMethod,
	getInventoryLevelEventTotalWeightSpcSamplingMethod,
} from "src/components/views/erp/spcSamplingMethods/inventoryLevelEventSpcSamplingMethods.tsx";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations.ts";
import { getWiivakalusteAddShopOrdersToBatchDataGridCustomColumns } from "src/tenantCustomizations/tenants/wiivakaluste/wiivakalusteAddShopOrdersToBatchDataGridCustomColumns.tsx";
import { WiivakalusteShopOrderBatchContextMenuComponents } from "src/tenantCustomizations/tenants/wiivakaluste/WiivakalusteShopOrderBatchContextMenuComponents.tsx";

export const wiivakalusteCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			accountingIntegrationEnabled: true,
			configuratorEnabled: true,
			projectActivityMaterialImportMethods: ["VERTEX"],
			customerOfferLineImportMethods: ["STANDARD_TABULAR", "VERTEX"],
			customerOrderLineImportMethods: ["STANDARD_TABULAR", "VERTEX"],
			deliveryPackageBundlingEnabled: true,
			jobQueueQrCodeEnabled: true,
			jobQueuePickingListEnabled: true,
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
	},
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getInventoryLevelEventQuantitySpcSamplingMethod(),
		getInventoryLevelEventTotalWeightSpcSamplingMethod(),
	],
	erp: {
		production: {
			shopOrderBatchContextMenuComponents: WiivakalusteShopOrderBatchContextMenuComponents,
			addShopOrdersToBatchView: {
				attributeFilterFields: [1],
				customColumns: getWiivakalusteAddShopOrdersToBatchDataGridCustomColumns,
			},
		},
	},
};
